/* ════════════════════════════════════════════════════════════════════
   Shared visual vocabulary for replay events.

   The timeline icons, the timeline popups and the info panel all present
   the SAME entity — a replay event — so they must draw the same glyph and
   speak the same name for the same kind. Color classes stay local to each
   CSS module (they depend on the surface), but glyphs and human names are
   defined once, here.
   ──────────────────────────────────────────────────────────────────── */

import type { ReplayEventType } from '../../../packetsReplay/extractReplayEvents'

/** pixelarticons glyph name per event kind (rendered via
 *  `pixelart-icons-font-<name>` classes). */
export const EVENT_ICON: Partial<Record<ReplayEventType, string>> = {
  damage: 'alert',
  death: 'close-box',
  kill_player: 'close-box',
  kill_mob: 'bullseye-arrow',
  chat: 'chat',
  command: 'code',
  dimension_change: 'arrows-vertical',
  respawn: 'reload',
  teleport: 'arrow-right-box',
  afk: 'moon-star',
  afk_end: 'user',
  high_activity: 'zap',
}

/** Human names — the type id is developer vocabulary. */
export const EVENT_NAME: Partial<Record<ReplayEventType, string>> = {
  damage: 'Урон',
  death: 'Смерть',
  kill_player: 'Убийство игрока',
  kill_mob: 'Убийство моба',
  chat: 'Сообщение',
  command: 'Команда',
  dimension_change: 'Смена измерения',
  respawn: 'Возрождение',
  teleport: 'Телепорт',
  afk: 'AFK',
  afk_end: 'Вернулся из AFK',
  high_activity: 'Высокая активность',
  low_activity: 'Затишье',
}
